import React from 'react';
import TableWithSummary from '../../../components/table/TableWithSummary';
import { COUPON_LIST_TABLE_EMPTY_TEXT } from '../../../constants/service/app/couponConstants';
import { couponListColumns } from './columns';
import { CouponListFilterOption, CouponListItem } from '../../../types/coupons/list-v2';
import { Sort } from '../../../types/common/options';

type CouponListProps = {
  list: CouponListItem[];
  totalCount: number;
  filterOption: CouponListFilterOption;
  sortOption: Sort<'id' | 'status' | 'name' | 'createDate'>;
  pagination: { pageNum: number; pageSize: number; pages: number };
  onFilter: (filter: Partial<CouponListFilterOption>) => void;
  onSort: (sort: Sort<'id' | 'status' | 'name' | 'createDate'>) => void;
  onPageChange: (page: number, pageSize: number) => void;
  onExcelDownload: () => void;
};

const INITIAL_FILTER_OPTION: CouponListFilterOption = {
  couponId: null,
  name: null,
  description: null,
  status: null,
  isDownloadable: 0,
  availableType: null,
  discountType: null,
  code: null,
  createDate: {
    startDate: null,
    endDate: null,
  },
};

const INITIAL_SORT_OPTION = [{ id: 'createDate', desc: true }];
const INITIAL_PAGINATION = { pageNum: 0, pageSize: 20, pages: 1 };

/** 문자열 Sort('-createDate') → 배열 형식([{id:'createDate', desc:true}]) 변환 */
const toTableSortOption = (sort: string): { id: string; desc: boolean }[] => {
  const desc = sort.startsWith('-');
  const id = desc ? sort.slice(1) : sort;
  return [{ id, desc }];
};

/** 배열 형식([{id:'createDate', desc:true}]) → 문자열 Sort('-createDate') 변환 */
const toStringSortOption = (sorted: { id: string; desc: boolean }[]): string => {
  if (!sorted.length) return '-createDate';
  const { id, desc } = sorted[0];
  return desc ? `-${id}` : id;
};

export const CouponList = (props: CouponListProps) => {
  const { list, totalCount, filterOption, sortOption, pagination, onFilter, onSort, onPageChange, onExcelDownload } = props;

  const tableSortOption = toTableSortOption(sortOption);

  const getList = (data: Record<string, unknown>) => {
    if (data.filterOption) {
      onFilter(data.filterOption as Partial<CouponListFilterOption>);
    }
    if (data.sortOption) {
      const sorted = data.sortOption as { id: string; desc: boolean }[];
      onSort(toStringSortOption(sorted) as Sort<'id' | 'status' | 'name' | 'createDate'>);
    }
    if (data.pagination) {
      const pag = data.pagination as { pageNum: number; pageSize: number };
      onPageChange(pag.pageNum, pag.pageSize);
    }
  };

  return (
    <div className="coupon-list">
      <TableWithSummary
        data={list}
        totalCnt={totalCount}
        initialOption={{
          filterOption: INITIAL_FILTER_OPTION,
          sortOption: INITIAL_SORT_OPTION,
          pagination: INITIAL_PAGINATION,
        }}
        isStriped={true}
        emptyText={COUPON_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={tableSortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={onExcelDownload}
        columns={(utils: Record<string, unknown>) =>
          couponListColumns({
            ...utils,
          })
        }
      />
    </div>
  );
};
